<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2>Zones</h2>
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <router-link :to="{ name:'ZoneManagerAdd' }" class="btn btn-success">
          <i class="fa fa-edit" aria-hidden="true"></i>Add Zone
        </router-link>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a class="nav-link active" data-toggle="tab" href="#main">Main</a>
          </li>
          <li class="nav-item" v-if="feature_multicast_enabled">
            <a class="nav-link" data-toggle="tab" href="#multicast">Multicast</a>
          </li>
        </ul>
        <br />
        <div class="tab-content">
          <div class="tab-pane fade show active" id="main" role="tabpanel">
            <ZoneTable :type="'main'"></ZoneTable>
          </div>
          <div class="tab-pane fade" id="multicast" role="tabpanel">
            <ZoneTable :type="'multicast'"></ZoneTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ZoneTable from '../../../components/Zone/ZoneTable'

export default {
  components: { ZoneTable },
  computed: {
    ...mapGetters({
      scoped_site_id: 'scopedSiteId',
      phoenix_settings: 'allPhoenixSettings'
    }),
    feature_multicast_enabled: function () {
      let setting = this.phoenix_settings.find(
        ps =>
          ps.site_id === this.scoped_site_id &&
          ps.domain === 'PHOENIX.FEATURE.MULTICAST' &&
          ps.setting === 'ENABLED'
      )

      return setting !== undefined ? setting.value === '1' : false
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', false)
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX.FEATURE')
  }
}
</script>

<style scoped>
</style>
